<template>
    <v-layout row wrap>
    <div v-if="needInit && getLanguageIcons && user">{{initData()}}</div>
    <v-flex xs12 v-if="!needInit">
        <v-card>  
            <v-card-text>
                 <v-layout row wrap>
                    <v-flex xs4>
                        <p v-if="qtype == 0">Title:</p>
                        <p v-else>{{questions_list[qtype-1]}}:</p>       
                    </v-flex>
                    <v-flex xs4>
                        <small>translated: </small>
                        <span v-for="(language,index) in myContent" :key=index>
                            <img v-if="language.translated" class="lang-icon" :src="getLanguageIcons[language.language_id-1].url"
                            @click ="showIndex = index"
                            />
                        </span>    
                    </v-flex>
                    <v-flex xs4>
                        <small>not translated: </small>
                        <span v-for="(language,index) in myContent" :key=index>
                            <img v-if="!language.translated" class="lang-icon" :src="getLanguageIcons[language.language_id-1].url"
                            @click ="editIndex = index"
                            />
                        </span>  
                    </v-flex>
                    <v-flex xs12 v-if="showIndex > -1">
                        <v-card>
                            <v-card-text>
                                <v-layout row wrap>
                                    <v-icon class="btn-close" @click="showIndex = -1">close</v-icon>  
                                    <v-flex xs1>
                                        <img class="lang-icon" :src="getLanguageIcons[showIndex].url"/>
                                        <v-icon @click="editIndex = showIndex; showIndex = -1;">edit</v-icon>
                                        <v-icon v-if="qtype != 0" @click ="clearTranslation(showIndex); showIndex = -1">delete</v-icon>
                                    </v-flex>
                                    <v-flex xs10 v-if="qtype == 0">
                                            <span>{{myContent[showIndex].content}}</span>
                                    </v-flex>
                                    <v-flex xs10 v-if="qtype == 1 || qtype == 6">
                                            <p>{{myContent[showIndex].content.description}}</p>
                                    </v-flex>
                                    <v-flex xs10 v-if="qtype == 2 || qtype == 3">
                                            <p>{{myContent[showIndex].content.description}}</p>
                                            <div v-html="processChoices(myContent[showIndex].content.choices,'')"> </div>
                                    </v-flex>
                                    <v-flex xs10 v-if="qtype == 4 || qtype == 5">
                                            <p>{{myContent[showIndex].content.description}}</p>
                                            <div v-html="processChoices(myContent[showIndex].content.choices, myContent[showIndex].content.other_descr + ': ________')"> </div>
                                    </v-flex>
                                    <v-flex xs10 v-if="qtype == 7 || qtype == 8">
                                            <p>{{myContent[showIndex].content.description}}</p>
                                            ({{myContent[showIndex].content.desc_first}}) - <span v-html="likert[qtype-7]"></span> - ({{myContent[showIndex].content.desc_last}})
                                    </v-flex>
                                    <v-flex xs1></v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 v-if="editIndex > -1">
                        <v-card>
                            <v-card-text>
                                <v-icon class="btn-close" @click="editIndex = -1">close</v-icon>  
                                <v-layout row wrap>
                                    <v-flex xs1>
                                        <img class="lang-icon" :src="getLanguageIcons[editIndex].url">
                                    </v-flex>
                                    <v-flex xs10 v-if="qtype == 0">
                                        <v-text-field                                
                                            label="Type description (and press Enter)"
                                            v-model="myContent[editIndex].content"
                                            @keydown.enter.prevent="saveElement(true)"
                                            @keydown.esc.prevent="editIndex = -1"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs10 v-if="qtype == 1 || qtype == 6">    
                                        <v-textarea
                                            v-model="myContent[editIndex].content.description"
                                            filled flat outlined :rows="5"                    
                                        ></v-textarea>
                                    </v-flex>
                                    <v-flex xs10 v-if="qtype == 2 || qtype == 3">
                                        <v-textarea
                                            label="Description:"
                                            v-model="myContent[editIndex].content.description"
                                            filled flat outlined :rows="3"                    
                                        ></v-textarea>
                                        <v-textarea
                                            v-model="myContent[editIndex].content.choices"
                                            label="Write choice into separated row:"
                                            filled flat outlined :rows="4"                    
                                        ></v-textarea>
                                    </v-flex>                                
                                    <v-flex xs10 v-if="qtype == 4 || qtype == 5">
                                        <v-textarea
                                            label="Description:"
                                            v-model="myContent[editIndex].content.description"
                                            filled flat outlined :rows="3"                    
                                        ></v-textarea>
                                        <v-textarea
                                            v-model="myContent[editIndex].content.choices"
                                            label="Write choice into separated row:"
                                            filled flat outlined :rows="4"                    
                                        ></v-textarea>
                                        <v-text-field                                
                                            label="Description of other"
                                            v-model="myContent[editIndex].content.other_descr"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs10 v-if="qtype == 7 || qtype == 8">
                                        <v-textarea
                                            label="Description:"
                                            v-model="myContent[editIndex].content.description"
                                            filled flat outlined :rows="3"                    
                                        ></v-textarea>
                                        <v-text-field                                
                                            label="Description of lower value"
                                            v-model="myContent[editIndex].content.desc_first"
                                        ></v-text-field>
                                        <v-text-field                                
                                            label="Description of upper value"
                                            v-model="myContent[editIndex].content.desc_last"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs1 align-self-end>
                                        <img @click="saveElement(true)" class="own-icon" src="@/assets/img/icons/confirm.svg"/>
                                    </v-flex>                                
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-flex> 


                 </v-layout>
            </v-card-text>   
          </v-card>
      </v-flex>
    
  </v-layout>
</template>

<script>
import axios from '../../axios-auth.js'
import {mapGetters} from 'vuex'

  export default {
    data() {
      return {
        needInit : false,
        myContent : null,
        myQuestionID: -1,
        showIndex : -1,
        editIndex: -1,
        channame: '',
        page: 1,
        questions_list: ['description',
                        'one choice',
                        'multi choice ',
                        'one choice with other',
                        'multi choice with other',
                        'free answer',
                        'Likert 5',
                        'Likert 7'
                    ],
        likert: ['<b>o</b> 1&nbsp;&nbsp;&nbsp;&nbsp;<b>o</b> 2&nbsp;&nbsp;&nbsp;&nbsp;<b>o</b> 3&nbsp;&nbsp;&nbsp;&nbsp;<b>o</b> 4 &nbsp;&nbsp;&nbsp;&nbsp;<b>o</b> 5',
                 '<b>o</b> 1&nbsp;&nbsp;&nbsp;&nbsp;<b>o</b> 2&nbsp;&nbsp;&nbsp;&nbsp;<b>o</b> 3&nbsp;&nbsp;&nbsp;&nbsp;<b>o</b> 4 &nbsp;&nbsp;&nbsp;&nbsp;<b>o</b> 5 &nbsp;&nbsp;&nbsp;&nbsp;<b>o</b> 6 &nbsp;&nbsp;&nbsp;&nbsp;<b>o</b> 7'
        ] 
      }
    },
    props: { 
        translations: Array, //{ type: Array, default: () => [] },
        qtype: Number,
//        que_id: Number,
        q_id: Number
    },    
    computed: 
        mapGetters([
                        'getLanguageIcons',
                        'user',
                        'getQueId'
                    ])
    ,
    mounted() {
        this.needInit = true
    },
   methods: {
    initData() {
        this.needInit = false  
        this.$store.commit('setFeedback', null)
        this.prepareContent(this.translations)
    },
    prepareContent(transs) {
        this.myQuestionID = this.q_id  
        this.myContent = []
        if (transs.length == 0) {
            for(let i = 0; i < this.getLanguageIcons.length; i++) {
                this.myContent.push(this.getEmptyElement(this.qtype, this.getLanguageIcons[i].id))
            }
        } else {
            for(let i = 0; i < this.getLanguageIcons.length; i++) {
                var found = false
                for(let j = 0; j < transs.length; j++) {
                  if (this.getLanguageIcons[i].id == transs[j].language_id) {
                      var _content = transs[j].content
                      if (this.qtype > 0) _content = JSON.parse(_content)
                      this.myContent.push( {
                            language_id: transs[j].language_id, 
                            translated: true, 
                            content: _content
                      })
                      found = true                      
                      break
                  }
                }
                if (!found) this.myContent.push(this.getEmptyElement(this.qtype, this.getLanguageIcons[i].id))                
            }
        }
        /* eslint-disable no-console */   
        // if user language not empty show
        for(let i = 0; i<this.myContent.length; i++) {
            if (this.myContent[i].language_id == this.user.lang_id) {
               if (this.myContent[i].translated)
                 this.showIndex = i;
               break;
            }
        }
             
    },
    clearTranslation(index) {
        this.myContent.splice(index,1,this.getEmptyElement(this.qtype, this.myContent[index].language_id))
        this.saveElement(false)
    },
    getLanguageIcon(id) {
        for(let i=0; i<this.getLanguageIcons.length; i++) {
            if (this.getLanguageIcons[i].id == id) return this.getLanguageIcons[i].url
        }
    },
    saveElement(translated) {
        if (translated) this.myContent[this.editIndex].translated = true; 
        var _content = this.myContent[this.editIndex].content
        if (this.qtype > 0) {
            _content = JSON.stringify(this.myContent[this.editIndex].content)           
        }
        const data = {
            questionnaire_id: this.getQueId,
            question_id: this.myQuestionID,
            qtype: this.qtype,
            lang_id: this.myContent[this.editIndex].language_id,
            content: _content,
            page: this.page
        }
        console.log(this.getQueId)
        console.log(data)
        axios.post('/save-questionaire-element', data, this.$store.getters.getAxiosConfig)
            .then(res => {                
                if (this.qtype == 0) {
                    this.$store.commit('setQueId', res.data.id)
                } else {
                    this.myQuestionID = res.data.id
                }
                this.editIndex = -1
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)          
            })
        },
        processChoices(list, other) {
            if (list.substring(list.length-1) == '\n') list = list.substring(0,list.length-1)
            list = list.replaceAll('\n', '</li><li>');
            list = '<ul><li>' + list + '</li>'
            if (other != '') list = list + '<li>' + other + '</li>'
            return list + '</ul>'
        },
        // definition for question types
        getEmptyElement(qt, lang_id) {
            switch (qt) {
                case 0: return {language_id: lang_id, translated: false, content: '' };
                case 6:
                case 1: return {language_id: lang_id, translated: false, content: { description : ''} };
                case 2: 
                case 3: return {language_id: lang_id, translated: false, content: { description : '', choices: ''} };
                case 4: 
                case 5: return {language_id: lang_id, translated: false, content: { description : '', choices: '', other_descr: ''} };
                case 7: 
                case 8: return {language_id: lang_id, translated: false, content: { description : '', desc_first: '', desc_last: ''} };
            }
        },
   }
  }
</script>

<style>

</style>        